module.exports = __webpack_public_path__ + "ab68ae1d8c85d67eaaf5dbdfd229de57.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/fannypack.png
// module id = 1837
// module chunks = 0